import styled, { css } from 'styled-components';

interface StatsContainerRootProps {
  outlined?: boolean;
  expandHeight?: boolean;
}

export const StatsContainerRoot = styled.div<StatsContainerRootProps>`
  background: linear-gradient(2deg, rgb(230, 230, 230) 0%, rgba(230, 230, 230, 0.25) 100%);
  border-radius: 4px;
  padding: ${(props) => (props.outlined ? '2px' : '0')};

  ${(props) =>
    props.expandHeight &&
    css`
      display: flex;
      flex-grow: 1;
    `}

  & + & {
    margin-top: 8px;
  }
`;

interface StatsContainerInnerProps {
  column?: boolean;
  subContainer?: boolean;
}

export const StatsContainerInner = styled.div<StatsContainerInnerProps>`
  background: #ffffff;
  border-radius: 4px;
  padding: ${(props) => (props.subContainer ? 'unset' : '10px 8px 8px 8px')};
  font-size: ${(props) => (props.subContainer ? 'unset' : '92%')};
  line-height: 1.4;
  display: flex;
  flex-direction: ${(props) => (props.column ? 'column' : 'row')};
  flex-wrap: wrap;
  row-gap: ${(props) => (props.column ? '4px' : '8px')};
  column-gap: 30px;
  flex-grow: 1;
`;
